import { Link } from "react-router-dom";
import { Reveal, Dots } from "./motion/Reveal";
import { useConsultation } from "./Consultation";
import Icon from "./Icon";

export default function CTASection({
  title = "Ready to Start Your Global Education Journey?",
  description = "Speak with our education advisors and take the first step toward finding the right destination, institution and academic pathway.",
}) {
  const openConsultation = useConsultation();
  return (
    <section className="hero-spotlight relative overflow-hidden" data-testid="final-cta-section">
      <div className="relative mx-auto max-w-[1440px] px-4 py-20 sm:px-6 lg:px-10 lg:py-28">
        <Reveal className="max-w-3xl">
          <Dots className="mb-5" />
          <h2 className="font-display text-3xl font-semibold leading-[1.12] tracking-tight text-white sm:text-4xl lg:text-5xl">
            {title}
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/70 sm:text-lg">{description}</p>
          <div className="mt-9 flex flex-wrap items-center gap-4">
            <button
              onClick={openConsultation}
              className="group inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-navy transition-colors duration-200 hover:bg-dot-amber hover:text-navy-dark"
              data-testid="cta-book-consultation-button"
            >
              Book a Free Consultation
              <Icon name="ArrowRight" className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
            </button>
            <Link
              to="/destinations"
              className="inline-flex items-center gap-2 rounded-full border border-white/25 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:border-white/60 hover:bg-white/5"
              data-testid="cta-explore-destinations-button"
            >
              Explore Destinations
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
